import { getRenderWidth } from "./Size";

export enum Fruit {
  IMAGE_1 = "IMAGE_1",
  IMAGE_2 = "IMAGE_2",
  IMAGE_3 = "IMAGE_3",
  IMAGE_4 = "IMAGE_4",
  IMAGE_5 = "IMAGE_5",
  IMAGE_6 = "IMAGE_6",
  IMAGE_7 = "IMAGE_7",
  IMAGE_8 = "IMAGE_8",
  IMAGE_9 = "IMAGE_9",
  IMAGE_10 = "IMAGE_10",
  IMAGE_11 = "IMAGE_11",
  IMAGE_12 = "IMAGE_12",
}

export type FruitType = keyof typeof Fruit;

export const getFruitFeature = (fruit: FruitType) => {
  switch (fruit) {
    case Fruit.IMAGE_1:
      return {
        radius: getRenderWidth() / 24,
        mass: 0.8,
        label: Fruit.IMAGE_1,
        score: 1,
      };
    case Fruit.IMAGE_2:
      return {
        radius: getRenderWidth() / 18,
        mass: 1,
        label: Fruit.IMAGE_2,
        score: 3,
      };
    case Fruit.IMAGE_3:
      return {
        radius: getRenderWidth() / 12,
        mass: 1,
        label: Fruit.IMAGE_3,
        score: 6,
      };
    case Fruit.IMAGE_4:
      return {
        radius: getRenderWidth() / 10,
        mass: 1,
        label: Fruit.IMAGE_4,
        score: 10,
      };
    case Fruit.IMAGE_5:
      return {
        radius: getRenderWidth() / 8,
        mass: 1,
        label: Fruit.IMAGE_5,
        score: 15,
      };
    case Fruit.IMAGE_6:
      return {
        radius: getRenderWidth() / 7,
        mass: 1,
        label: Fruit.IMAGE_6,
        score: 21,
      };
    case Fruit.IMAGE_7:
      return {
        radius: getRenderWidth() / 6,
        mass: 1,
        label: Fruit.IMAGE_7,
        score: 28,
      };
    case Fruit.IMAGE_8:
      return {
        radius: getRenderWidth() / 5.3,
        mass: 1,
        label: Fruit.IMAGE_8,
        score: 36,
      };
    case Fruit.IMAGE_9:
      return {
        radius: getRenderWidth() / 4.6,
        mass: 1,
        label: Fruit.IMAGE_9,
        score: 45,
      };
    case Fruit.IMAGE_10:
      return {
        radius: getRenderWidth() / 3.95,
        mass: 1,
        label: Fruit.IMAGE_10,
        score: 55,
      };
    case Fruit.IMAGE_11:
      return {
        radius: getRenderWidth() / 3.5,
        mass: 1,
        label: Fruit.IMAGE_11,
        score: 66,
      };
    case Fruit.IMAGE_12:
      return {
        radius: getRenderWidth() / 3.5,
        mass: 1,
        label: Fruit.IMAGE_12,
        score: 100,
      };
  }
};

export const getRandomFruitFeature = () => {
  const fruits = Object.values(Fruit).slice(0, 5);
  const randomIndex = Math.floor(Math.random() * fruits.length); // 무작위 인덱스 선택
  return getFruitFeature(fruits[randomIndex]);
};

export const getNextFruitFeature = (currentFruit: Fruit) => {
  // 현재 과일의 순서를 찾기
  const currentIndex = Object.values(Fruit).indexOf(currentFruit);

  if (currentIndex === -1) {
    // 주어진 과일이 유효하지 않은 경우, 예외 처리
    return null;
  }

  // 다음 과일의 순서 계산
  const nextIndex = (currentIndex + 1) % Object.values(Fruit).length;

  // 다음 과일의 종류 가져오기
  const nextFruit = Object.values(Fruit)[nextIndex];

  // 다음 과일의 특성 가져오기
  const feature = getFruitFeature(nextFruit);

  return feature;
};
